export function handleHttpAuthorizationError(status, store, router) {
  const normalizedStatus = Number(status) || 0;
  if (normalizedStatus === 401) {
    store.dispatch("clearAuth");
    if (router.currentRoute.path !== "/") {
      router.push("/");
    }
  } else if (normalizedStatus === 403) {
    store.dispatch("addNotification", {
      type: "warning",
      title: "无权执行该操作",
    });
  } else if (normalizedStatus === 503) {
    store.dispatch("addNotification", {
      type: "warning",
      title: "认证或权限服务暂不可用，请稍后重试",
    });
  }
}
